"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    radioGroupClassNames: function() {
        return radioGroupClassNames;
    },
    useRadioGroupStyles_unstable: function() {
        return useRadioGroupStyles_unstable;
    }
});
const _react = require("@griffel/react");
const radioGroupClassNames = {
    root: 'fui-RadioGroup'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f6jr5hl"
    },
    vertical: {
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f6jr5hl{align-items:flex-start;}",
        ".f1vx9l62{flex-direction:column;}"
    ]
});
const useRadioGroupStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(radioGroupClassNames.root, styles.root, state.layout === 'vertical' && styles.vertical, state.root.className);
    return state;
}; //# sourceMappingURL=useRadioGroupStyles.styles.js.map
